// Teksty interfejsu bloga. Celowo poza i18next: strony blogowe mają stały język
// wynikający z URL (/pl/blog/, /de/blog/), a nie z ustawień przeglądarki —
// prerender musi dawać ten sam wynik co przeglądarka użytkownika.
const STRINGS = {
  pl: {
    home: "Strona główna",
    blog: "Blog",
    tableOfContents: "Spis treści",
    publishedOn: "Opublikowano",
    updatedOn: "Zaktualizowano",
    readingTime: (m) => `${m} min czytania`,
    relatedTitle: "Powiązane artykuły",
    aboutAuthor: "O autorze",
    authorPrefix: "Autor",
    moreFromAuthor: "Artykuły tego autora",
    tags: "Tagi",
    tagTitle: (tag) => `Tag: ${tag}`,
    tagIntro: (tag, n) =>
      `${n === 1 ? "Jeden artykuł" : `Artykuły (${n})`} oznaczone tagiem „${tag}”.`,
    pageTitle: (n) => `Strona ${n}`,
    prevPage: "← Poprzednia strona",
    nextPage: "Następna strona →",
    breadcrumbAria: "Ścieżka nawigacji",
    rss: "Kanał RSS",
    allPosts: "Wszystkie artykuły",
    emptyTag: "Brak artykułów z tym tagiem.",
    backToBlog: "← Wróć na blog",
    minRead: "min",
  },
  de: {
    home: "Startseite",
    blog: "Blog",
    tableOfContents: "Inhaltsverzeichnis",
    publishedOn: "Veröffentlicht",
    updatedOn: "Aktualisiert",
    readingTime: (m) => `${m} Min. Lesezeit`,
    relatedTitle: "Verwandte Artikel",
    aboutAuthor: "Über den Autor",
    authorPrefix: "Autor",
    moreFromAuthor: "Artikel dieses Autors",
    tags: "Schlagwörter",
    tagTitle: (tag) => `Schlagwort: ${tag}`,
    tagIntro: (tag, n) =>
      `${n === 1 ? "Ein Artikel" : `Artikel (${n})`} mit dem Schlagwort „${tag}“.`,
    pageTitle: (n) => `Seite ${n}`,
    prevPage: "← Vorherige Seite",
    nextPage: "Nächste Seite →",
    breadcrumbAria: "Brotkrümelnavigation",
    rss: "RSS-Feed",
    allPosts: "Alle Artikel",
    emptyTag: "Keine Artikel mit diesem Schlagwort.",
    backToBlog: "← Zurück zum Blog",
    minRead: "Min.",
  },
};

export default function strings(lang) {
  return STRINGS[lang] || STRINGS.pl;
}
